<template>
  <div class="page">
    <div class="logo" @click="changePage('/home')"></div>
    <div class="icon2"></div>
    <div class="btn1"></div>
    <div class="btn2"></div>
    <div class="btn3"></div>
    <div class="iconCustomer" @click="changePage('/faq')"></div>
  </div>
</template>
<script setup lang="ts">
const changePage = function (pageName: string) {
  router.push(pageName)
}
</script>
<style scoped>
.logo {
  margin-top: 6.37rem;
  margin-left: 5.63rem;
  width: 8.19rem;
  height: 9rem;
  background-image: url(/src/assets/img/icon.png);
  background-size: contain;
  background-repeat: no-repeat;
  background-position: left;
  z-index: 99;
  position: relative;
}

.icon2 {
  position: relative;
  margin-top: 9.81rem;
  margin-left: 7.06rem;
  width: 30.44rem;
  height: 16.94rem;
  background-image: url(/src/assets/img/down/icon2.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}

.btn1 {
  position: relative;
  margin-top: 5.5rem;
  margin-left: 7.31rem;
  width: 25.44rem;
  height: 4.19rem;
  background-image: url(/src/assets/img/down/btn1.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}

.btn2 {
  position: relative;
  margin-top: 3.69rem;
  margin-left: 7.31rem;
  width: 25.44rem;
  height: 4.19rem;
  background-image: url(/src/assets/img/down/btn2.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}

.btn3 {
  position: relative;
  margin-top: 3.69rem;
  margin-left: 7.31rem;
  width: 25.44rem;
  height: 4.19rem;
  background-image: url(/src/assets/img/down/btn3.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}
.iconCustomer {
  position: fixed;
  right: 2.31rem;
  bottom: 5.5rem;
  width: 23.44rem;
  height: 12.56rem;
  background-image: url(/src/assets/img/customer.png);
  background-size: contain;
  background-repeat: no-repeat;
  z-index: 1;
}
</style>
